'use strict';

/*******************************************************************************
 Adding custom filters to plupload
 http://www.plupload.com/docs/File-Filters#max_img_resolution
 *******************************************************************************/

var options = {
	backToTop: true
};

plupload.addFileFilter('image_resolution', function(options, file, cb) {
	let self = this;
	let errorMessage = '';

	let img = new window.moxie.image.Image();

	function finalize(result) {
		// cleanup
		img.destroy();
		img = null;

		// if rule has been violated in one way or another, trigger an error
		if (!result) {
			self.trigger('Error', {
				code: plupload.IMAGE_DIMENSIONS_ERROR,
				message: errorMessage,
				file: file
			});
		}
		cb(result);
	}

	// Helper function to calculate the result based on a string operator
	function calc(val1, operator, val2) {
		if (operator === '>') {
			let result = val1 > val2;
			if (!result) {
				errorMessage = 'The image is too big';
			}
			return result;
		}
		if (operator === '=') {
			let result = val1 === val2;
			if (!result) {
				errorMessage = 'This image size is not allowed';
			}
			return result;
		}
		if (operator === '<') {
			let result = val1 < val2;
			if (!result) {
				errorMessage = 'The image is too small. Must be at least ' + val1 + 'px wide';
			}
			return result;
		}
		if (operator === '<=') {
			let result = val1 <= val2;
			if (!result) {
				errorMessage = 'The image is too small. Must be at least ' + val1 + 'px wide';
			}
			return result;
		}
		if (operator === '>=') {
			let result = val1 >= val2;
			if (!result) {
				errorMessage = 'The image is too big';
			}
			return result;
		}

		throw 'Invalid operator ' + operator + '!';
	}

	img.onload = function() {
		if (options.width !== undefined && options.height !== undefined) {
			let width = calc(options.width.size, options.width.operator, img.width);
			let height = calc(options.hight.size, options.hight.operator, img.height);
			finalize(width && height);
			return;
		}
		if (options.width !== undefined) {
			finalize(calc(options.width.size, options.width.operator, img.width));
			return;
		}
		if (options.height !== undefined) {
			finalize(calc(options.height.size, options.width.operator, img.height));
			return;
		}
	};

	img.onerror = function() {
		finalize(false);
	};

	img.load(file.getSource());
});

plupload.addFileFilter('min_img_resolution', function(maxRes, file, cb) {
	if (file.type === 'image/svg+xml') {
		let img = new window.moxie.image.Image();

		function finalize(result) {
			// cleanup
			img.destroy();
			img = null;

			cb(true);
		}

		img.onload = function() {
			finalize(true);
		};

		img.onerror = function() {
			finalize(false);
		};

		img.load(file.getSource());
	} else {
		let self = this;
		let img = new window.moxie.image.Image();

		function finalize(result) {
			// cleanup
			img.destroy();
			img = null;

			// if rule has been violated in one way or another, trigger an error
			if (!result) {
				self.trigger('Error', {
					code: plupload.IMAGE_DIMENSIONS_ERROR,
					message: 'Image should be at least ' + maxRes[0] + ' pixels wide.',
					file: file
				});
			}
			cb(result);
		}

		img.onload = function() {
			if (img.type === 'svg') {
				finalize(true);
			} else {
				finalize(img.width >= maxRes[0] && img.height >= maxRes[1]);
			}
		};

		img.onerror = function() {
			finalize(false);
		};

		img.load(file.getSource());
	}
});
